import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { cloneDeep, isEqual } from 'lodash-es';

type TranslationItem = {lang:string, title:string, content:string};

@Injectable({providedIn:'root'})
export class LetterTranslationsService {
    protected changeEvent = new Subject<{type:'load'|'remove'|'add'|'change', data:Array<TranslationItem>}>();
    get onChange () {
        return this.changeEvent.asObservable();
    }
    _origin:TranslationItem[] = [];
    _list:Array<TranslationItem> = [];
    changed:boolean = false;
    get list ():Array<TranslationItem> {
        return this._list;
    }
    set list (list:Array<TranslationItem>) {
        if (!list) list = [];
        this._list.splice(0, this._list.length);
        this._list.push(...list);
        this.changeEvent.next({type:'add', data:this.list});
    }
    constructor(
    ) {
    }
    load (list:TranslationItem[]) {
        this.list = list;
        this._origin = cloneDeep(list);
        this.changed = false;
        this.changeEvent.next({type:'load', data:this.list})
    }
    // push (li:TranslationItem):number {
    //     const result = this._list.push(li);
    //     this.changeEvent.next({type:'add', data:[li]});
    //     this.changed = this.hasChanged();
    //     return result;
    // }
    // splice (start:number, deleteCount?:number, ...replacement:Array<TranslationItem>):Array<TranslationItem> {
    //     const result = this._list.splice(start, deleteCount, ...replacement);
    //     this.changed = this.hasChanged();
    //     if (deleteCount === 1 && replacement.length === 1) {
    //         this.changeEvent.next({type:'change', data:[...result, ...replacement]});
    //     } else {
    //         if (deleteCount > 0) this.changeEvent.next({type:'remove', data:result});
    //         if (replacement.length > 0) this.changeEvent.next({type:'add', data:replacement});
    //     }
    //     return result;
    // }
    // remove (item:TranslationItem) {
    //     const index = this._list.findIndex(li=>li.lang === item.lang);
    //     if (index !== -1) {
    //         this._list.splice(index, 1);
    //         this.changed = this.hasChanged();
    //         this.changeEvent.next({type:'remove', data:this.list});
    //     }   
    // }
    protected hasChanged ():boolean {
        return !isEqual(this._origin, this._list);
    }


}


